
import Service from "layouts/services/Service";
import ProtectedRoute from "routes/protectedRoutes.js";
import Manage from "layouts/services/Manage";
const ProductRoutes = [

  {
    route: "services/edit/:productId",
    key: "ServiceProduct",
    component: <ProtectedRoute check="logout"><Service /></ProtectedRoute>
  },
  {
    route: "/services/manage/:pageNo",
    key: "manage-services",
    component: <ProtectedRoute check="logout"><Manage /></ProtectedRoute>
  }
  ];

export default ProductRoutes;
 
